import React, { Component, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { BackArrowIcon, BackIcon, defaultLogo, DownloadIcon, FilterIcon } from "../../Icons";
import ParentGroupInfo from "../../components/TeamManagement/ParentGroupInfo";
import { ApplicationIcon, GroupIcon, UserIcon } from "../../assets/Icons";
import UserAdd from "../../modal/UserAddData";
import UserAddData from "../../modal/UserAddData";
import GroupAddData from "../../modal/GroupAddData";
import VerifyAnimationModal from '../../modal/VerifyAnimationModal'
import CSVModalTable from "../../modal/CSVModalTable";
import { GroupCSVUploadModal, UserCSVUploadModal } from "../../modal/UploadCSVModal";
import { ASSIGN_APPLICATION_LIST, GROUP_BREADCRUMB, GROUP_DETAILS, GROUP_LIST, GROUP_USERS_LIST } from "../../apiClient/apiEndpoints";
import Move from "../../modal/Move";
import apiClient from "../../apiClient";

const {
    BackButton,
    GridView,
    SearchBar,
    NormalGradientButton,
    Breadcrumbs,
    SimTabs,
    SimCheckBox,
    ApplicationCard,
    SimFilter,
    SimModal,
    SimToggleSwitch
} = UiComponents;

const { useUnoSelector } = UnoStoreHooks

const TeamApplicationManagement = () => {
    const configData = useUnoSelector((state) => state.config);
    const params = useParams();
    const UUID = params?.uuid;
    const [search, setSearch] = useState("");
    const [activeCrumb, setActiveCrumb] = useState("");

    const [showCSVTable, setShowCSVTable] = useState({ data: null, status: false, type: null });
    const [showCSVUpload, setShowCSVUpload] = useState({ type: null, status: false });

    const [groupModal, setGroupModal] = useState(false);
    const [userModal, setUserModal] = useState(false);
    const [showMove, setShowMove] = useState(false);
    const [showVerifyModal, setShowVerifyModal] = useState(false);

    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

    const [showfilter, setShowFilter] = useState(false);

    const [groupDetails, setGroupDetails] = useState({
        avatar: null,
        groups: null,
        handDown: false,
        inherit: false,
        name: null,
        type: { color: null, name: null },
        users: null,
        uuid: null
    });
    const [assignedResourceList, setAssignedResourceList] = useState([]);
    const [allTabsData, setAllTabsData] = useState([])
    const [breadcrumbList, setBreadcrumbList] = useState([])


    const navigate = useNavigate();
    const backClick = () => {
        navigate(-1);
    };

    const getGroupDetails = async () => {
        try {
            let data = await apiClient.get(`${configData.config.UNO_URL}${GROUP_DETAILS}/${UUID}`);
            setGroupDetails(data);

        } catch (error) {
            console.log(error);
        }
    };

    const getAssignedApplication = async () => {
        try {
            let data = await apiClient.get(`${configData.config.UNO_URL}${ASSIGN_APPLICATION_LIST}/${UUID}`);
            setAssignedResourceList(data);
        } catch (error) {
            console.log(error);
        }
    }

    const getGroupBreadcrumb = async () => {
        try {
            let data = await apiClient.get(`${configData.config.UNO_URL}${GROUP_BREADCRUMB}/${UUID}`);
            let list = data || [];
            setBreadcrumbList(list.reverse());
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        setActiveCrumb(UUID);
        getGroupDetails();
        getAssignedApplication();
        getGroupBreadcrumb()
    }, [UUID])

    useEffect(() => {
        let resourceTab = [
            {
                navItem: { title: "Assigned Application", count: assignedResourceList.length },
                content: {
                    component: () => (
                        <div className="groups-tab for-applications">
                            <GridView>
                                <div className="module-item mb-2">
                                    <span className="assignedcheckboxde"><SimCheckBox /> </span>
                                    <div className="bthumbnail">
                                        <img className="boardthumbnail" src="https://cdn.simulanis.io/sso/logos/ffs.jpg" alt="" />
                                    </div>
                                    <div className="info-detail">
                                        <p>Precision Coating Redefined with Industrial Paint Simulation.</p>
                                    </div>
                                </div>
                                <div className="module-item mb-2">
                                    <span className="assignedcheckboxde"><SimCheckBox /> </span>
                                    <div className="bthumbnail">
                                        <img className="boardthumbnail" src="https://cdn.simulanis.io/sso/uno/production/whiteboards/6e026365-88d5-47c2-8c4a-152b719ee4b1/thumnbail/9efa3b0c-2690-4dce-8c0a-b903d4c80adb.jpg" alt="" />
                                    </div>
                                    <div className="info-detail">
                                        <p>Precision Coating Redefined with </p>
                                    </div>
                                </div>
                                <div className="module-item mb-2">
                                    <span className="assignedcheckboxde"><SimCheckBox /> </span>
                                    <div className="bthumbnail">
                                        <img className="boardthumbnail" src="https://cdn.simulanis.io/sso/uno/production/resources/78df3d5c-6d1a-4bc8-8e76-efad75002a1d/thumbnail/Fire-Safety.jpg" alt="" />
                                    </div>
                                    <div className="info-detail">
                                        <p>Precision Coating Redefined with Industrial Paint Simulation.</p>
                                    </div>
                                </div>

                                {/* {assignedResourceList.map((app, i) => {
                                    if (!app?.name?.toLowerCase()?.includes(search?.toLowerCase())) return null;
                                    return (
                                        <ApplicationCard
                                            key={i}
                                            assignedResources={0}
                                            onClick={handleAppClick}
                                            showResources={true}
                                            name={app.name}
                                            description={app.description}
                                            logo={app.icon}
                                            resourceClick={clickResource}
                                            checkbox={<SimCheckBox />}
                                            showCheckbox={true}
                                            checked={true}
                                            handleResourceClick={AssignApplicationNavigate}
                                        />
                                    )
                                })} */}
                            </GridView>
                        </div>
                    ),
                },
                key: "3",
            },
        ]

        setAllTabsData([...resourceTab]);

    }, [assignedResourceList, search])

    const clickResource = () => {
        console.log("dksah dhjsad d hasjk");
    };

    const handleAppClick = () => {
        console.log("clicked on app");
    };

    const handleBreadCrumbClick = (key) => {
        navigate(`/team-management/${key.key}`)
    };

    const AssignApplicationNavigate = () => {
        navigate(`/dashboard`)
    }

    // Filter
    const body = document.body;
    const openFilter = () => {
        setShowFilter(!showfilter);
        if (!showfilter) {
            body.classList.add("filter-active");
        } else {
            body.classList.remove("filter-active");
        }
    };

    const filterOptions = [
        {
            name: "Status",
            tags: [
                { name: "Hello", key: "active", value: 4 },
                { name: "Hello2", key: "active", value: 5 },
                { name: "Hello3", key: "active", value: 6 },
            ],
        }, {
            name: "Lorem Ipsum",
            tags: [
                { name: "Hello", key: "hey", value: 1 },
                { name: "Hello5", key: "hey", value: 2 },
                { name: "Hello6", key: "hey", value: 3 },
            ],
        },
    ];

    const handleShowCSVUpload = (type) => {
        setShowCSVUpload({ type: type, status: true });
        setGroupModal(false);
        setUserModal(false);
    }

    const handleCloseModal = () => {
        setGroupModal(false);
        setUserModal(false);
        setShowCSVUpload({ type: null, status: false });
    }


    const handleVerifyModalShow = () => {
        setShowMove(false);
        setShowVerifyModal(true);
        setTimeout(() => {
            setShowVerifyModal(false);
        }, 1500);
    };

    return (
        <>
            <div className="team-management">
                <div className="page-title with-fuctions">
                    <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                    <div className="title-n-breads-wrapper">
                        <div className="title-n-breads">
                            <p>Team Management </p>
                            <span className="separator"> {""} </span>
                            <Breadcrumbs data={breadcrumbList} handleClick={handleBreadCrumbClick} activeCrumb={activeCrumb} />
                        </div>
                    </div>
                    {/* <NormalGradientButton icon={<UserIcon />} text="Users" onClick={() => setUserModal(true)} />
                    <NormalGradientButton icon={<GroupIcon />} text="Group" onClick={() => setGroupModal(true)} /> */}
                    {/* {activeTab == "application" &&
                        <>
                            {selectedApplication.length > 0 ?
                                <NormalGradientButton icon={<ApplicationIcon />} text="Unassign Application" onClick={handelUnassignApplication} />
                                : */}
                    <NormalGradientButton icon={<ApplicationIcon />} text="Application" onClick={() => navigate(`/resource-management`)} />
                    {/* }
                        </>
                    } */}

                </div>

                <div className="team-functions">
                    <div className="team-info">
                        <ParentGroupInfo userMode={true} setUserModal={setUserModal} setGroupModal={setGroupModal} details={groupDetails} getSubGroupsList={null} getGroupDetails={getGroupDetails} />
                    </div>

                    <div className="team-stats">
                        <SimTabs data={allTabsData} defaultActiveKey="3" nav_wrapper_class="with-search">
                            <div className="search-parent">
                                <SearchBar
                                    onClick={() => { }}
                                    placeholder="Search..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />

                                <div className="filterbtn" onClick={openFilter}>
                                    <div className="btninadjust">
                                        <FilterIcon />
                                        {selectedCheckboxes.length ? <span className="num berhere">{selectedCheckboxes.length}</span> : null}
                                    </div>
                                </div>

                                <SimFilter
                                    showfilter={showfilter}
                                    selectedCheckboxes={selectedCheckboxes}
                                    setSelectedCheckboxes={setSelectedCheckboxes}
                                    filterOptions={filterOptions}
                                    onToggleFilter={openFilter}
                                />
                            </div>
                        </SimTabs>
                    </div>
                </div>
            </div>


            <SimModal showModal={groupModal} onHide={() => handleCloseModal()} centered={true} size="md">
                <GroupAddData showCSVOption={true} CSVUpload={() => handleShowCSVUpload("group")} onHide={() => handleCloseModal()} type="create" getSubGroupsList={null} />
            </SimModal>

            <SimModal showModal={userModal} onHide={() => handleCloseModal()} centered={true} size="md">
                <UserAddData showCSVUpload={() => handleShowCSVUpload("user")} onHide={() => handleCloseModal()} getUsersList={null} />
            </SimModal>

            <SimModal showModal={showCSVUpload.status} onHide={() => handleCloseModal()} centered={true} size="md">
                {showCSVUpload.type === "group" &&
                    <GroupCSVUploadModal
                        onNext={(e) => setShowCSVTable({ ...e, type: "group" })}
                        onHide={() => handleCloseModal()}
                    />}

                {showCSVUpload.type === "user" &&
                    <UserCSVUploadModal
                        onNext={(e) => setShowCSVTable({ ...e, type: "user" })}
                        onHide={() => handleCloseModal()}
                    />}
            </SimModal>

            <SimModal showModal={showCSVTable.status} onHide={() => setShowCSVTable({ data: null, status: false, type: null })} centered={false} size="lg">
                <CSVModalTable
                    data={showCSVTable}
                    onHide={() => setShowCSVTable(false)}
                />
            </SimModal>

            <SimModal showModal={showMove} onHide={() => setShowMove(false)} centered={true} size="md">
                <Move onHide={() => setShowMove(false)} handleVerifyModalShow={handleVerifyModalShow} />
            </SimModal>

            <SimModal
                showModal={showVerifyModal}
                onHide={() => setShowVerifyModal(false)}
                centered={true}
                size="md"
            >
                <VerifyAnimationModal message="Move Successfully" />
            </SimModal>

        </>
    );
};

export default TeamApplicationManagement;